import moment from 'moment'

export default class Submission {
  constructor(data) {
    this.populateWithData(data);
  }
  populateWithData(data) {
    data = data || {};
    data = JSON.parse(JSON.stringify(data));

    this.id = data.id || null;
    this.pid = data.pid || null;
    this.identifier = data.identifier || null;
    this.event_code = data.event_code || null;
    this.sample_type = data.sample_type || null;
    this.sample_type_id = data.sample_type_id || null;

    if(this.sample_type && !this.sample_type_id) {
      this.sample_type_id = this.sample_type.id || null;
    }
    this.turnaround = data.turnaround || null;
    this.turnaround_id = data.turnaround_id || null;

    if(this.turnaround && !this.turnaround_id) {
      this.turnaround_id = this.turnaround.id || null;
    }
    this.submission_status_logs = data.submission_status_logs || [];

    if(data.submission_soil) {
      this.setSubmissionSoil(data.submission_soil);
    } else if(typeof this.submission_soil === 'object') {
      delete this.submission_soil;
    }

    if(data.submission_tissue) {
      this.setSubmissionTissue(data.submission_tissue);
    } else if(typeof this.submission_tissue === 'object') {
      delete this.submission_tissue;
    }

    if(data.samples) {
      this.setSamples(data.samples);
    } else if(typeof this.samples === 'object') {
      delete this.samples;
    }

    return this;
  }
  setSubmissionSoil(data) {
    data = data || {};
    data = JSON.parse(JSON.stringify(data));

    const submission_soil = {
      grower: data.grower || null,
      irrigated: data.irrigated || null,
      next_crop1: data.next_crop1 || null,
      next_crop2: data.next_crop2 || null,
      next_crop3: data.next_crop3 || null,
      next_yield1: data.next_yield1 || null,
      next_yield2: data.next_yield2 || null,
      next_yield3: data.next_yield3 || null,
      zone: data.zone || null,
    };

    return this.submission_soil = submission_soil;
  }
  setSubmissionTissue(data) {
    data = data || {};
    data = JSON.parse(JSON.stringify(data));

    const submission_tissue = {
      crop: data.crop || null,
      cropstage: data.cropstage || null
    };

    return this.submission_tissue = submission_tissue;
  }
  setSamples(collection) {
    collection = collection || [];
    collection = JSON.parse(JSON.stringify(collection));

    if(!collection.length) {
      return this.samples = [];
    }

    const samples = [];

    collection.forEach((data) => {
      let sample = {
        identifier: data.identifier || null,
        test_package_sample_id: data.test_package_sample_id || null,
        test_package_samples: data.test_package_samples || [],
        sample_status_logs: data.sample_status_logs || []
      };

      if(data.sample_soil) {
        sample.sample_soil = {
          depth_start: data.sample_soil.depth_start || null,
          depth_end: data.sample_soil.depth_end || null,
          depth_total: data.sample_soil.depth_total || null
        };
      }

      if(data.sample_septic) {
        sample.sample_septic = {
          depth_start: data.sample_septic.depth_start || null,
          depth_end: data.sample_septic.depth_end || null,
          depth_total: data.sample_septic.depth_total || null,
          texture: data.sample_septic.texture || null,
          sieve: data.sample_septic.sieve || null,
          sar: data.sample_septic.sar || null,
          ec: data.sample_septic.ec || null,
          cole: data.sample_septic.cole || null,
          dispersion: data.sample_septic.dispersion || null
        };
      }

      if(data.add_ons) {
        sample.add_ons = data.add_ons;
      } else {
        sample.add_ons = [];
      }

      samples.push(sample);
    });

    return this.samples = collection;
  }
  getSampleType() {
    return (this.sample_type ? this.sample_type : null);
  }
  getTestPackage() {
    let test_package = null;

    if(this.samples && this.samples.length) {
      this.samples.forEach((sample) => {
        if(sample.test_package_samples && sample.test_package_samples.length) {
          sample.test_package_samples.forEach((test_package_sample) => {
            if(test_package_sample.test_package && !test_package_sample.add_on) {
              test_package =  test_package_sample.test_package;
            }
          });
        }
      });
    }

    return test_package;
  }
  getTitle() {
    const test_package = this.getTestPackage();
    const title = [
      (this.sample_type ? this.sample_type.name : null),
      (this.identifier || null),
      (test_package ? test_package.name : null),
    ];
    const filtered = title.filter(Boolean);

    return filtered.join(' - ');
  }
  static formatField(field) {
    return field.split('_').join(' ').replace(/^(.)|\s+(.)/g, function (j) { return j.toUpperCase() });
  }
  getStatus() {
    if(this.submission_status_logs && this.submission_status_logs.length) {
      const log = this.submission_status_logs[0];

      if(log.submission_status) {
        return log.submission_status.status;
      }
    }

    return null;
  }
  getTestPackageCost() {
    const test_package = this.getTestPackage();

    if(test_package && test_package.cost) {
      return +(test_package.cost);
    }

    return null;
  }
  getAddOnsFromSample(sample) {
    const add_ons = [];

    if(sample.add_ons && sample.add_ons.length) {
      sample.add_ons.forEach((add_on) => {
        if(add_on.cost_add_on) {
          add_ons.push(add_on);
        }
      });
    }

    return add_ons;
  }

  getAddOns() {
    const add_ons = [];

    if(this.samples && this.samples.length) {
      this.samples.forEach((sample) => {
        if(sample.add_ons && sample.add_ons.length) {
          sample.add_ons.forEach((add_on) => {
            if(add_on.cost_add_on) {
              add_ons.push(add_on);
            }
          });
        }
      });
    }

    return add_ons;
  }

  getAddOnTotal() {
    let total = null;
    
    if(this.samples && this.samples.length) {
      total = 0;
      this.getAddOns().forEach((add_on) => {
        if(add_on.cost_add_on) {
          total += +(add_on.cost_add_on);
        }
      });
    }

    return total;
  }

  getTotal(applyTurnaraound) {
    let total = this.getTestPackageCost() || 0;

    total += (this.getAddOnTotal() || 0);
    if(applyTurnaraound) {
      if(this.turnaround) {
        switch(this.turnaround.surcharge_type) {
          case 'percent':
            total = total * (1 + (+(this.turnaround.surcharge) / 100));
            break;
          case 'flat':
            total += +(this.turnaround.surcharge);
            break;
        }
      }
    }

    return total ? total : null;
  }

  static formatValue(type, value) {
    switch(type) {
      case 'datetime':
        return moment(value).format('dddd, MMMM Do YYYY, h:mm a');
      case 'boolean':
        return (!(+(value)) ? 'Yes' : 'No');
      default:
        return value;
    }
  }

  getSubmissionMetaData() {
    const meta = [];
    let included = ['identifier', 'event_code'];
    let types = { created_at: 'datetime', updated_at: 'datetime' };
    
    included.forEach((key) => {
      meta.push({label: this.constructor.formatField(key), value: this.constructor.formatValue(types[key], this[key])});
    });

    if(this.submission_soil) {
      included = ['grower', 'zone', 'irrigated', 'next_crop1', 'next_yield1', 'next_crop2', 'next_yield2', 'next_crop3', 'next_yield3'];
      types = { 'irrigated': 'boolean' };
      
      included.forEach((key) => {
        if(!this.submission_soil[key]) { return; }
        meta.push({ label: this.constructor.formatField(key), value: this.constructor.formatValue(types[key], this.submission_soil[key]) });
      });
    }

    if(this.submission_tissue) {
      included = ['crop','cropstage'];
      types = {};
      included.forEach((key) => {
        if(!this.submission_tissue[key]) { return; }
        meta.push({label: this.constructor.formatField(key), value: this.constructor.formatValue(types[key], this.submission_tissue[key])});
      });
    }

    return meta;

  }

  getTurnaroundText() {
    if(this.turnaround) {
      switch(this.turnaround.surcharge_type) {
        case 'percent':
          return `${this.turnaround.name}(${this.turnaround.surcharge}% Surcharge)`;
        case 'flat':
          return `${this.turnaround.name}($${this.turnaround.surcharge} Surcharge)`;
      }
    }

    return null;
  }
  getSamples() {
    const samples = this.samples || null;

    if(!samples) {
      return samples;
    }

    samples.forEach((sample, index) => {
      sample.title = null;
      if(sample.test_package_samples && sample.test_package_samples.length) {
        sample.title = (sample.test_package_samples[0].name || null);
      }

      sample.status = null;

      if(sample.sample_status_logs && sample.sample_status_logs.length) {
        const log = sample.sample_status_logs[0];

        if(log.sample_status) {
          sample.status = log.sample_status.status;
        }
      }

      const meta = [];

      if(sample.sample_soil) {
        const included = ['depth_start', 'depth_end', 'depth_total', 'created_at', 'updated_at'];
        const types = { created_at: "datetime", updated_at: "datetime" };
        
        included.forEach((key) => {
          if(!sample.sample_soil[key]) { return; }
          meta.push({
            label: this.constructor.formatField(key),
            value: this.constructor.formatValue(types[key], sample.sample_soil[key])
          });
        });
      }

      if(sample.sample_septic) {
        const included = [
          "depth_start",
          "depth_end",
          "depth_total",
          "texture",
          "sieve",
          "sar",
          "ec",
          "cole",
          "dispersion",
          "created_at",
          "updated_at",
        ];
        const types = {
          sar: "boolean",
          ec: "boolean",
          cole: "boolean",
          dispersion: "boolean",
          created_at: "datetime",
          updated_at: "datetime",
        };

        included.forEach((key) => {
          if (!sample.sample_septic[key]) { return; }
          
          meta.push({label: this.constructor.formatField(key), value: this.constructor.formatValue(types[key], sample.sample_septic[key])});
        });
      }

      sample.cost = null;

      if(sample.add_ons) {
        const add_ons = [];
        let cost = 0;

        sample.add_ons.forEach((add_on) => {
          add_ons.push(add_on.name);

          if(add_on.cost_add_on) {
            cost += +(add_on.cost_add_on);
          }
        });

        if(add_ons.length) {
          meta.push({label: 'Add Ons', value: add_ons.join(', ')});
        }

        if(cost) {
          sample.cost = cost;
        }
      }

      sample.meta = [];
      sample.meta = meta;
      samples[index] = sample;
    });

    return samples;

  }

  validate() {
    const errors = [];

    if(!this.event_code) {
      errors.push('Event code is required');
    }

    if(!this.identifier) {
      errors.push('Identifier is required');
    }

    if(!this.sample_type || !this.sample_type.id) {
      errors.push('Sample type is required');
    }

    if(this.submission_soil) {
      if(!this.submission_soil.grower) {
        errors.push('Grower is required');
      }
    }

    if(this.submission_tissue) {
      if(!this.submission_tissue.crop) {
        errors.push('Crop is required');
      }

      if(!this.submission_tissue.cropstage) {
        errors.push('Crop stage is required');
      }
    }

    if(this.samples && this.samples.length) {
      this.samples.forEach((sample) => {
        if(!sample.identifier) {
          errors.push('Sample identifier is required');
        }

        if(!sample.test_package_sample_id) {
          errors.push('Sample test package not specified');
        }

        if(sample.sample_soil) {
          if(!sample.sample_soil.depth_start) {
            errors.push('Depth start is required');
          }

          if(!sample.sample_soil.depth_end) {
            errors.push('Depth end not specified');
          }

          if(!sample.sample_soil.depth_total) {
            errors.push('Depth total not specified');
          }
        }
        if(sample.sample_septic) {
          if(!sample.sample_septic.depth_start) {
            errors.push('Depth start is required');
          }

          if(!sample.sample_septic.depth_end) {
            errors.push('Depth end not specified');
          }

          if(!sample.sample_septic.depth_total) {
            errors.push('Depth total not specified');
          }

          if(!sample.sample_septic.texture) {
            errors.push('Texture not specified');
          }
        }
      });
    } else {
      errors.push('Samples are missing');
    }

    return {status: (+!(errors.length)), errors}

  }

}
